import axios from "axios";
import { useState, useEffect } from "react";

export default function TestImage() {
  const [image, setImage] = useState("");

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_PHP_APP_URL}/proxyImage`,
          { responseType: "blob" } // Important!
        );

        const imageUrl = URL.createObjectURL(response.data);
        setImage(imageUrl);

      } catch (error) {
        console.error("Erreur lors du chargement de l'image :", error);
      }
    };

    fetchImage();
  }, []);

  return (
    <>
      <h1 style={{ color: "black" }}>Page de test image</h1>
      {image && <img src={image} alt="image" />}
    </>
  );
}
